import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  padding: 1.25rem;

  .qtd,
  .emb,
  .val-custo,
  .num-doc {
    width: 150px;
    min-width: 30px;
  }

  .un {
    width: 250px;
    min-width: 50px;
  }

  .produto {
    flex: 1;
    min-width: 100px;
  }
`;
